import { namespace as createVuexClass } from 'vuex-class';

export const namespace = 'userRoles';
export const store = createVuexClass(namespace);

export const FETCH_PERMISSIONS_FEATURES = 'fetchPermissionsFeatures';

export const FETCH_PERMISSIONS_ROLES = 'fetchPermissionsRoles';
export const PERMISSIONS_ROLES_LIST_NAVIGATION = 'permissionsRolesListNavigation';
export const UPDATE_PERMISSIONS_ROLES_LIST_STATE = 'updatePermissionsRolesListState';
export const USER_ROLES_LIST_NAVIGATION = 'userRolesListNavigation';

export const FETCH_PERMISSIONS_OF_ROLE = 'fetchPermissionsOfRole';
export const RESET_PERMISSIONS_OF_ROLE = 'resetPermissionsOfRole';

export const UPDATE_PERMISSIONS_FEATURES_OF_ROLE = 'updatePermissionsFeaturesOfRole';

export const ADD_USER_ROLE_WITH_PERMISSIONS = 'addUserRoleWithPermissions';
export const DEL_USER_ROLE = 'deleteUserRole';

export const SET_STATUS = 'setStatus';
export const SET_EDITION = 'setEdition';
export const SET_ADDITION = 'setAddition';

export const SET_NOTIFICATION = 'setNotification';
export const UPDATE_NAVIGATION = 'updateNavigation';
export const SET_ERROR = 'setError';

export const REINIT = 'reinit';
export const SET_SELECTED = 'setSelected';

export interface INavigation {
  start: number;
  elementsPerPage: number;
  direction: 'backward' | 'forward';
  isLastElementsPage: boolean;
}

export interface IUserRolesState {
  [view: string]: boolean;
}

export interface IUserRolesStatePayload {
  stateKey: string;
  view: string;
  stateValue: boolean;
}

export interface IUserRolesListState {
  [state: string]: IUserRolesState;
}

export interface UserRole {
  id: string;
  displayName: string;
}

export interface IUserRole {
  userRolesList: UserRole[];
  navigation: INavigation;
  total: number;
}

export interface IUserRoles {
  userRolesListComponentsState: IUserRolesListState;
  userRoles: IUserRole;
}

export interface IPermissionsFeatures {
  id: string;
  groups: string[];
  type: string;
}

export interface IPermission {
  featureGroup: string;
  id: string;
  permissionType: string;
  resourceGroup: string;
  subFeatureGroup?: string;
}

export interface IRolePermissions {
  id: string;
  displayName: string;
  permissions?: string[];
}

export interface INotification {
  content: string;
  status: string;
  isOpen: boolean;
  type: string;
}

export interface UserRolesState {
  featuresPermissions: IPermissionsFeatures[];
  roles: IUserRoles;
  rolePermissions: IRolePermissions;
  editing: boolean;
  notification: INotification;
  error: string | undefined;
  addition: boolean;
  selected: UserRole | undefined;
}
